import {
  ICustomField,
  WSDataTypes
} from "@wingspanhq/payments/dist/interfaces";
import * as Yup from "yup";
import {
  ICustomFields,
  ICustomFieldValue
} from "@wingspanhq/payments/dist/interfaces/customFields";
import {
  convertDataTypeBooleanToBoolean,
  convertDataTypeBooleanToString
} from "../shared/utils/convertDataTypeBoolean";

export function getYupValidationSchema(formFields: ICustomField[]) {
  const validationSchema: any = {};
  formFields.forEach(field => {
    let validationRule: any = Yup.string();
    switch (field.type) {
      case WSDataTypes.String:
        if (field.required) {
          validationRule = validationRule.required(`${field.name} is required`);
        }
        break;
      case WSDataTypes.Boolean:
        validationRule = Yup.boolean();
        if (field.required) {
          validationRule = validationRule.required(`${field.name} is required`);
        }
        break;
      default:
        if (field.required) {
          validationRule = validationRule.required(`${field.name} is required`);
        }
    }
    validationSchema[field.key] = validationRule;
  });
  return validationSchema;
}

export function getDefaultValuesForAdditionalData(
  formFields: ICustomField[],
  labels?: ICustomFields
) {
  const defaultValues: Record<string, ICustomFieldValue> = {};
  formFields.forEach(field => {
    switch (field.type) {
      case WSDataTypes.String:
        defaultValues[field.key] = labels?.[field.key] || "";
        break;
      case WSDataTypes.Boolean:
        defaultValues[field.key] = convertDataTypeBooleanToBoolean(
          labels?.[field.key]
        );
        break;
    }
  });
  return defaultValues;
}

export function prepareCollaboratorLabelsRequest(
  formFields: ICustomField[],
  values: { [key: string]: any }
) {
  const labels: any = {};
  formFields.forEach(field => {
    switch (field.type) {
      case WSDataTypes.String:
        labels[field.key] = values[field.key] ? String(values[field.key]) : "";
        break;

      case WSDataTypes.Boolean:
        labels[field.key] = convertDataTypeBooleanToString(values[field.key]);
        break;
    }
  });
  return labels;
}

function booleanFieldToFilterRequest(filterValue: string[]) {
  if (filterValue.length === 1) {
    if (filterValue[0] === "true") {
      return "true";
    } else {
      return {
        "!=": "true"
      };
    }
  }

  return;
}

function stringFieldToFilterRequest(filterValue: string) {
  return {
    contains: filterValue
  };
}

export function customFieldToFiltersRequest(
  customField: ICustomField,
  filterValue?: string | string[]
) {
  if (!filterValue) {
    return;
  }

  switch (customField.type) {
    case WSDataTypes.Boolean:
      if (Array.isArray(filterValue)) {
        return booleanFieldToFilterRequest(filterValue);
      } else {
        console.error("Boolean field should be an array");
        return;
      }
    default:
      if (typeof filterValue === "string") {
        return stringFieldToFilterRequest(filterValue);
      } else {
        console.error("String field should be a string");
      }
  }
}
